<template>
  <div class="monit-page report-chart">
    <div
      class="no-chart row center middle-lg middle-sm middle-xs"
      v-show="!hasChart"
    >
      <div class="col-xs-12 center-xs">
        <logo-icon customWidth="10em" fillColor="#3d9161c4" />
        <div class="btn-report">
          <b-btn variant="3v3" @click="openChartForm">GERAR GRÁFICO</b-btn>
        </div>
      </div>
    </div>

    <div v-show="hasChart" class="has-chart">
      <div class="row">
        <div class="col-xs start-xs">
          <b-btn variant="3v3" @click="openChartForm">GERAR GRÁFICO</b-btn>
        </div>
      </div>
      <div class="row center-xs h-100">
        <div class="h-100 col-xs-12 container-grafico">
          <apexchart
            v-if="hasChart"
            width="100%"
            height="100%"
            :series="series"
            :options="options"
          ></apexchart>
        </div>
      </div>
    </div>

    <chart-form
      v-if="!loadingEQP"
      :show-form="showForm"
      :eqps="eqps"
      :show-eqp="loadingEQP"
      @close-form="showForm = false"
      @chart-data="searchChartSeries"
    />
  </div>
</template>

<script>
import { chart } from "@/api";
import { isMobile } from "@/pages/components/helpers";
import { organizeLog } from "@/pages/components/monit/charts";
export default {
  name: "report-chart",
  created() {
    this.$emit("title-change", "Gráficos");
    this.loadFormOptions();
  },
  data() {
    return {
      //view
      hasChart: false,
      showForm: false,
      loadingEQP: false,
      options: {}, //apexcharts
      series: [], //apexcharts
      options: [], //apexcharts
      eqps: [{ UNIT: "Carregando unidades..." }],
      units: [],
      axesData: {
        left: [],
        right: [],
      },
      axesKeys: ["left", "right"],
      yaxis: {
        left: "",
        right: "",
      },
      selectedAxe: "",
    };
  },
  methods: {
    isMobile(ref) {
      return isMobile(ref);
    },
    loadFormOptions() {
      let regexFIR = /FIR/g;
      this.loadingEQP = true;
      chart
        .listEqpsOpt()
        .then((ret) => {
          const sensors = ret.sensors.map((e) => {
            e.EQP = "SENSOR";
            e.UNIT = e.NAME.match(regexFIR) ? "L" : e.UNIT;
            return e;
          });

          this.eqps = [
            ...ret.valves.map((e) => ({
              FK_EQP: e.FK_EQP,
              NAME: e.NAME,
              EQP: "ACTUATOR",
              UNIT: e.NAME.match(regexFIR) ? "L" : "m³",
              TYPE: "VOLUME",
            })),
            ...ret.valves.map((e) => ({
              FK_EQP: e.FK_EQP,
              NAME: e.NAME,
              EQP: "ACTUATOR",
              UNIT: "m³/h",
              TYPE: "VAZÃO",
            })),
            ...ret.dirs.map((e) => ({
              NAME: e.NAME,
              EQP: "DIR",
              UNIT: "%",
              TYPE: "SINAL",
            })),
            ...ret.dirs.map((e) => ({
              NAME: e.NAME,
              EQP: "DIR",
              UNIT: "V",
              TYPE: "BATERIA",
            })),
            ...ret.mtds.map((e) => ({
              NAME: e.NAME,
              EQP: "MTD",
              UNIT: "%",
              TYPE: "SINAL",
            })),
            ...ret.mtds.map((e) => ({
              NAME: e.NAME,
              EQP: "MTD",
              UNIT: "V",
              TYPE: "BATERIA",
            })),
            ...sensors,
          ];
        })
        .then((_) => {
          this.loadingEQP = false;
        })
        .catch((err) => {
          this.loadingEQP = false;
          alert("Ocorreu um erro ao buscar as opções para eixos do gráfico.");
        });
    },
    openChartForm() {
      this.showForm = true;
    },
    resetMultiAxe() {
      this.series = [];
      this.options = {};
      this.axesData = {
        left: [],
        right: [],
      };
      this.yaxis = {
        left: "",
        right: "",
      };
    },
    searchChartSeries(data) {
      wait.show();
      this.resetMultiAxe();

      chart
        .makeChart(data)
        .then((axes) => {
          // console.log('CHART -> ',axes)
          if (!axes[0].length && !axes[1].length) {
            alert("Não há dados para nenhum dos eixos no período solicitado.");
            return false;
          } else return this.makeLogArray(axes);
        })
        .then((ret) => {
          if (ret) {
            this.drawChart();
          } else this.hasChart = false;
        })
        .catch((err) => {
          wait.hide();
          console.log(err);
          alert("Ocorreu um erro na obtenção de dados ou criação do gráfico.");
        });
    },
    makeLogArray(axes) {
      return new Promise((resolve, reject) => {
        let axesCounter = 0;
        let leftAxeCounter = 0;
        let rightAxeCounter = 0;
        for (let a = 0; a < axes.length; a++) {
          axesCounter++;
          let key = this.axesKeys[a];
          let axe = axes[a];
          for (let i = 0; i < axe.length; i++) {
            let element = axe[i];
            // console.log('ELEMENT ',element)
            let column =
              element.EQP == "SENSOR"
                ? [
                    {
                      NAME: element.NAME,
                      TYPE: element.CONDITION.TYPES[0],
                      UNIT: element.CONDITION.UNITS[0],
                      PER_READING: element.CONDITION.PER_READING || false, // ← aqui
                    },
                  ]
                : [element.COLUMN];
            organizeLog(
              element,
              element.EQP,
              element.NAME,
              column,
              "chartsPage",
            )
              .then((result) => {
                if (!a) leftAxeCounter++;
                else rightAxeCounter++;
                // console.log(result.value)
                if (result.status) this.axesData[key].push(result.value);
                else console.log(result.log);
                if (
                  leftAxeCounter == axes[0].length &&
                  rightAxeCounter == axes[1].length &&
                  axesCounter == axes.length
                ) {
                  resolve(true);
                }
              })
              .catch((err) => reject(err));
          }
        }
      });
    },
    drawChart() {
      let colors = [
        "rgba(255, 0, 0, 0.5)", //'red'
        "rgba(0, 0, 255, 0.5)", //'blue'
        "rgba(0, 255, 0, 0.5)", //'green'
        "rgba(0, 0, 0, 0.5)", //'black'
        "rgba(255, 0, 255, 0.5)", //'pink'
        "rgba(255, 255, 0, 0.5)", //'yellow'
        "rgba(0, 255, 255, 0.5)", //'cyan'
        "rgba(255, 160, 0, 0.5)", //'orange'
        "rgba(160, 0, 255, 0.5)", //'purple'
        "rgba(0, 255, 160, 0.5)", //'teal'
      ];
      let yaxis = [];
      let left = this.axesData.left;
      let leftLength = this.axesData.left.length;
      for (let i = 0; i < leftLength; i++) {
        let e = left[i];
        let eqp = e.info.EQP;
        let column =
          eqp == "SENSOR" ? e.info.CONDITION.TYPES[0] : e.info.COLUMN;
        let chart = e[column];
        let measure = chart.measure;
        let type = chart.type;
        let name = `${measure} - ${eqp} ${e.name}`;
        if (i == 0) {
          this.yaxis.left = name;
          yaxis.push({
            labels: {
              formatter: function (val, index) {
                return `${val.toFixed(2)} ${chart.unit}`;
              },
            },
            seriesName: name,
            title: {
              text: `${chart.unit}`,
            },
          });
        } else {
          yaxis.push({
            labels: {
              formatter: function (val, index) {
                return `${val.toFixed(2)} ${chart.unit}`;
              },
            },
            seriesName: this.yaxis.left,
            show: false,
          });
        }
        this.series.push({
          name,
          type,
          data: chart.data,
        });
        // console.log('SERIES e ',e, ' ',e[column]);
      }
      let right = this.axesData.right;
      let rightLength = right.length;
      if (rightLength) {
        for (let i = 0; i < rightLength; i++) {
          let e = right[i];
          let eqp = e.info.EQP;
          let column =
            eqp == "SENSOR" ? e.info.CONDITION.TYPES[0] : e.info.COLUMN;
          let chart = e[column];
          let measure = chart.measure;
          let type = chart.type;
          let name = `${measure} - ${eqp} ${e.name}`;
          let opposite = true;
          if (i == 0) {
            this.yaxis.right = name;
            yaxis.push({
              labels: {
                formatter: function (val, index) {
                  return `${val.toFixed(2)} ${chart.unit}`;
                },
              },
              opposite,
              seriesName: name,
              title: {
                text: `${chart.unit}`,
              },
            });
          } else {
            yaxis.push({
              labels: {
                formatter: function (val, index) {
                  return `${val.toFixed(2)} ${chart.unit}`;
                },
              },
              opposite,
              seriesName: this.yaxis.right,
              show: false,
            });
          }
          this.series.push({
            name,
            type,
            data: chart.data,
          });
        }
      }
      this.options = {
        chart: {
          type: "line",
          stacked: false,
          zoom: {
            autoScaleYaxis: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors,
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
            format: "dd/MM/yyyy HH:mm",
          },
        },
        yaxis,
        tooltip: {
          followCursor: true,
          x: {
            show: true,
            format: "dd/MM/yyyy HH:mm",
          },
          shared: true,
          // Apex docs: If you want to have irregular timeseries, shared tooltip won’t play nicely.
        },
        legend: {
          horizontalAlign: "center",
        },
      };
      this.hasChart = true;
      wait.hide();
    },
  },
};
</script>

<style scoped>
.no-chart {
  height: 80vh;
  margin-left: -55px;
}
.has-chart {
  height: 80vh;
  margin-top: 15px;
  padding: 4px;
}
.btn-report {
  margin-top: 20px;
}
.form-general-data {
  padding: 0 4px;
  margin-bottom: 5px;
}
.selected-axes {
  display: block;
  height: 50%;
}
.error-axe {
  color: #f22424;
}
.form-axe {
  border-left: 1px solid rgb(62, 152, 212);
  color: rgb(62, 152, 212);
  padding-left: 4px;
  margin-bottom: 5px;
  max-height: 336px;
  overflow: auto;
}
.max-height {
  height: 52vh;
}
.container-grafico > div {
  height: 100%;
}
@media screen and (max-width: 1000px) {
  .form-axe {
    margin-top: 10px;
    margin-left: 5px;
    padding-left: 25px;
  }
}
@media screen and (max-width: 767px) {
  .no-chart {
    margin-left: 0;
  }
  .monit-page {
    padding: 0;
  }
  .btn-report {
    margin-top: 20px;
  }
}
</style>
